import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectStripe } from 'react-stripe-elements';
import get from 'lodash.get';

import { setPaymentStarted, makePaymentErrorOccured, onValueChange, makeRecurringPaymentRequest } from '../reducer';

import { Form } from 'semantic-ui-react';

import { DeviceHelper } from '../../../helpers/deviceHelper';
import { getMappedAddress } from '../../../helpers/formBuilderHelper';
import { getErrorMessage } from '../../../helpers/donationErrorHelper';

import Card from './card';
import CoverFee from './coverFee';
import DonateButton from './donationButton';
import DonationErrorMessage from './donationErrorMessage';
import { InjectReCaptcha } from '../../../components/common/reCaptcha';

import { displayNameKeys } from '../../../constants/displayNameOptions';
import { DonationType } from '../../../constants/donationType';
import { salutationTypes } from '../../../constants/salutation';
import { erorrMessages } from '../constants/errorMessages';
import { loadingStatus } from '../../../constants/loading';
import { MAX_DONATION_VALUE } from '../../../constants';
import { RECAPTCHA_SITE_KEY } from '../../../env';
import { donationRecurringFrequency } from '../../../constants/recurring';
import { paths } from '../constants';

import './index.css';

class MakeRecurringPaymentFormContainer extends Component {
    componentDidUpdate() {
        if (this.props.donation.paymentInProgress === loadingStatus.SUCCESS) {
            if (this.props.match.url.endsWith('/')) {
                this.props.history.push(`${this.props.match.url}thankyou`);
            } else {
                this.props.history.push(`${this.props.match.url}/thankyou`);
            }
        }
    }

    handleSubmit = ev => {
        const win = window;

        if (RECAPTCHA_SITE_KEY && win.grecaptcha) {
            win.grecaptcha.ready(_ => {
                win.grecaptcha
                    .execute(RECAPTCHA_SITE_KEY, { action: "subscribe" })
                    .then(token => {
                        this.proceedSubmit(ev, token);
                    })
            })
        }
        else {
            this.proceedSubmit(ev);
        }
    }

    proceedSubmit = (ev, verificationToken = null) => {
        this.props.setPaymentStarted();

        // We don't want to let default form submission happen here, which would refresh the page.
        ev.preventDefault();
        // Within the context of `Elements`, this call to createToken knows which Element to
        // tokenize, since there's only one in this group.

        // TODO: handle case when it fails
        this.props.stripe.createToken({
            name: `${this.props.donation.customer.firstName} ${this.props.donation.customer.lastName}`
        }).then(this.submitPayment.bind(this, verificationToken))
            .catch((error) => {
                this.props.makePaymentErrorOccured(error);
            });
    }

    getDisplayName = () => {
        const displayNameOption = get(this.props.donation, paths.SELECTED_DISPLAY_NAME_OPTION);
        return displayNameOption === displayNameKeys.asCustomName ? get(this.props, 'donation.displayName') : null;
    };

    submitPayment = (verificationToken, { complete, token, error }) => {
        const donation = {
            amount: this.props.donation.amount,
            frequency: donationRecurringFrequency.monthly,
            payment: {
                token: token.id,
                cardBrand: token.card.brand,
                cardCountry: token.card.country,
                cardExpiryMonth: token.card.exp_month,
                cardExpiryYear: token.card.exp_year,
                cardLast4Digits: token.card.last4,
                coverFee: this.props.donation.coverProcessingFee
            },
            pageType: 1,
            type: DonationType.Online,
            organizationId: get(this.props, 'page.organization.id'),
            campaignId: get(this.props, 'page.campaign.id'),
            device: {
                type: DeviceHelper.getDeviceType(),
                platform: DeviceHelper.getDevicePlatform()
            },
            donor: {
                salutation: this.props.donation.customer.salutation !== salutationTypes.None ? this.props.donation.customer.salutation : null,
                email: this.props.donation.customer.email,
                firstName: this.props.donation.customer.firstName,
                lastName: this.props.donation.customer.lastName,
                businessName: this.props.donation.customer.isBehalfOfCompany ? this.props.donation.customer.businessName : null,
                newsletter: this.props.donation.customer.newsletter,
                phoneNumber: this.props.donation.phoneNumber,
                address: getMappedAddress(this.props.donation.address)
            },
            issueReceipt: true
        };
        this.props.makePayment(donation, this.props.donation.idempotencyKey, verificationToken);
        if (complete) {
            complete('success');
        }
    }

    isTooMuchValue = () => {
        return get(this.props, 'donation.paymentRequestAmount') > MAX_DONATION_VALUE;
    }

    render() {
        const donationAmount = get(this.props, 'donation.amount');
        const serverErrorOccured = get(this.props, 'donation.serverErrorOccured');
        const serverErrorKey = get(this.props, 'donation.serverErrorKey');
        const isTooMuchValue = this.isTooMuchValue();

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <Card />
                </Form.Field>

                <Form.Field>
                    <CoverFee amount={donationAmount} />
                </Form.Field>

                <DonateButton disabled={isTooMuchValue} />

                {
                    isTooMuchValue &&
                    <DonationErrorMessage dismiss={false}
                        errorMessage={erorrMessages.MaxValueError} />
                }
                {
                    serverErrorOccured &&
                    <DonationErrorMessage dismiss={true}
                        errorMessage={getErrorMessage(serverErrorKey)} />
                }
            </Form>
        );
    }
}

const mapState = state => {
    return {
        donation: state.donation,
        page: state.page
    }
}

const mapDispatch = dispatch => {
    return {
        onValueChange(path, value) {
            dispatch(onValueChange(path, value));
        },
        makePayment: (donation, idempotencyKey, verificationToken) => {
            dispatch(makeRecurringPaymentRequest(donation, idempotencyKey, verificationToken));
        },
        setPaymentStarted: () => {
            dispatch(setPaymentStarted());
        },
        makePaymentErrorOccured: (error) => {
            dispatch(makePaymentErrorOccured(error));
        }
    };
};

const MakeRecurringPaymentForm = withRouter(connect(mapState, mapDispatch)(InjectReCaptcha(injectStripe(MakeRecurringPaymentFormContainer))));
export default MakeRecurringPaymentForm;
